// extracted by mini-css-extract-plugin
export default {"collection":"Collection_collection__brYoG","inner":"Collection_inner__TT+M+","space":"Collection_space__Qk0i1","furnitures":"Collection_furnitures__l9vAc"};